/**
 * Route for `data-visibility-toggle-assigned-users-only-vs-all`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { DataVisibilityToggleAssignedUsersOnlyVsAllPage } from "../features/data-visibility-toggle-assigned-users-only-vs-all/DataVisibilityToggleAssignedUsersOnlyVsAllPage";

export const dataVisibilityToggleAssignedUsersOnlyVsAllRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/data-visibility-toggle-assigned-users-only-vs-all",
	component: DataVisibilityToggleAssignedUsersOnlyVsAllPage,
});

export default dataVisibilityToggleAssignedUsersOnlyVsAllRoute;
